import { render, staticRenderFns } from "./MarryPlanPage.vue?vue&type=template&id=50b9b3b2"
import script from "./MarryPlanPage.vue?vue&type=script&lang=js"
export * from "./MarryPlanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports